import { SEARCH_TYPES } from '../constants';

/*
  algorithmOptions：Options for different algorithms
  similarity： display of the Sequence identity (%) option
  automaticShow：display of the automatic option
  automaticLong：different type of the automatic option
 */
export const configOptions = {
    // Nucleotide Input - Nucleotide Database
    nucTypeNucDbConfigs: {
        algorithmOptions: [
            {
                value: 'megablast',
                label: 'MegaBlast',
                key: 'megaBlast',
                default: true,
                children: {
                    wordSize: [
                        {
                            value: '16',
                        },
                        {
                            value: '20',
                        },
                        {
                            value: '24',
                        },
                        {
                            value: '28',
                            default: true,
                        },
                        {
                            value: '32',
                        },
                        {
                            value: '48',
                        },
                        {
                            value: '64',
                        },
                        {
                            value: '128',
                        },
                        {
                            value: '256',
                        },
                    ],
                    matchScores: [
                        {
                            value: '1,-2',
                            default: true,
                        },
                        {
                            value: '1,-3',
                        },
                        {
                            value: '1,-4',
                        },
                        {
                            value: '2,-3',
                        },
                        {
                            value: '4,-5',
                        },
                        {
                            value: '1,-1',
                        },
                    ],
                    gaps: [
                        {
                            value: '0,0',
                            label: 'Linear',
                            default: true,
                        },
                        {
                            value: '5,2',
                            label: 'Existence: 5 Extension: 2',
                        },
                        {
                            value: '2,2',
                            label: 'Existence: 2 Extension: 2',
                        },
                        {
                            value: '1,2',
                            label: 'Existence: 1 Extension: 2',
                        },
                        {
                            value: '0,2',
                            label: 'Existence: 0 Extension: 2',
                        },
                        {
                            value: '3,1',
                            label: 'Existence: 3 Extension: 1',
                        },
                        {
                            value: '2,1',
                            label: 'Existence: 2 Extension: 1',
                        },
                        {
                            value: '1,1',
                            label: 'Existence: 1 Extension: 1',
                        },
                    ],
                },
            },
            {
                value: 'blastn',
                label: 'Blastn',
                key: 'blastn',
                children: {
                    wordSize: [
                        {
                            value: '4',
                        },
                        {
                            value: '7',
                        },
                        {
                            value: '11',
                            default: true,
                        },
                        {
                            value: '15',
                        },
                    ],
                    matchScores: [
                        {
                            value: '1,-2',
                        },
                        {
                            value: '1,-3',
                        },
                        {
                            value: '1,-4',
                        },
                        {
                            value: '2,-3',
                            default: true,
                        },
                        {
                            value: '4,-5',
                        },
                        {
                            value: '1,-1',
                        },
                    ],
                    gaps: [
                        {
                            value: '4,4',
                            label: 'Existence: 4 Extension: 4',
                        },
                        {
                            value: '2,4',
                            label: 'Existence: 2 Extension: 4',
                        },
                        {
                            value: '0,4',
                            label: 'Existence: 0 Extension: 4',
                        },
                        {
                            value: '3,3',
                            label: 'Existence: 3 Extension: 3',
                        },
                        {
                            value: '6,2',
                            label: 'Existence: 6 Extension: 2',
                        },
                        {
                            value: '5,2',
                            label: 'Existence: 5 Extension: 2',
                            default: true,
                        },
                        {
                            value: '4,2',
                            label: 'Existence: 4 Extension: 2',
                        },
                        {
                            value: '2,2',
                            label: 'Existence: 2 Extension: 2',
                        },
                    ],
                },
            },
            {
                value: 'blastn-short',
                label: 'Blastn-short',
                key: 'blastnShort',
                children: {
                    wordSize: [
                        {
                            value: '4',
                        },
                        {
                            value: '7',
                            default: true,
                        },
                        {
                            value: '11',
                        },
                        {
                            value: '15',
                        },
                    ],
                    matchScores: [
                        {
                            value: '1,-2',
                        },
                        {
                            value: '1,-3',
                        },
                        {
                            value: '1,-4',
                        },
                        {
                            value: '2,-3',
                            default: true,
                        },
                        {
                            value: '4,-5',
                        },
                        {
                            value: '1,-1',
                        },
                    ],
                    gaps: [
                        {
                            value: '4,4',
                            label: 'Existence: 4 Extension: 4',
                        },
                        {
                            value: '2,4',
                            label: 'Existence: 2 Extension: 4',
                        },
                        {
                            value: '0,4',
                            label: 'Existence: 0 Extension: 4',
                        },
                        {
                            value: '3,3',
                            label: 'Existence: 3 Extension: 3',
                        },
                        {
                            value: '6,2',
                            label: 'Existence: 6 Extension: 2',
                        },
                        {
                            value: '5,2',
                            label: 'Existence: 5 Extension: 2',
                            default: true,
                        },
                        {
                            value: '4,2',
                            label: 'Existence: 4 Extension: 2',
                        },
                        {
                            value: '2,2',
                            label: 'Existence: 2 Extension: 2',
                        },
                    ],
                },
            },
        ],
        similarity: true,
        automaticShow: true,
        automaticLong: true,
        lowComplexityRegion: true,
    },
    // Nucleotide Input - Protein Database
    nucTypeProtDbConfigs: {
        algorithmOptions: [
            {
                value: 'blastx-fast',
                label: 'Blastx-fast',
                key: 'blastxFast',
                default: true,
                children: {
                    matrix: [
                        {
                            value: 'PAM30',
                        },
                        {
                            value: 'PAM70',
                        },
                        {
                            value: 'PAM250',
                        },
                        {
                            value: 'BLOSUM80',
                        },
                        {
                            value: 'BLOSUM62',
                            default: true,
                        },
                        {
                            value: 'BLOSUM45',
                        },
                        {
                            value: 'BLOSUM50',
                        },
                        {
                            value: 'BLOSUM90',
                        },
                    ],
                    wordSize: [
                        {
                            value: '2',
                        },
                        {
                            value: '3',
                        },
                        {
                            value: '6',
                            default: true,
                        },
                    ],
                },
            },
        ],
        similarity: false,
        automaticShow: false,
        lowComplexityRegion: true,
    },
    // Protein Input - Protein Database
    protTypeProtDbConfigs: {
        algorithmOptions: [
            {
                value: 'blastp-fast',
                label: 'Blastp-fast',
                key: 'blastpFast',
                default: true,
                children: {
                    matrix: [
                        {
                            value: 'PAM30',
                        },
                        {
                            value: 'PAM70',
                        },
                        {
                            value: 'PAM250',
                        },
                        {
                            value: 'BLOSUM80',
                        },
                        {
                            value: 'BLOSUM62',
                            default: true,
                        },
                        {
                            value: 'BLOSUM45',
                        },
                        {
                            value: 'BLOSUM50',
                        },
                        {
                            value: 'BLOSUM90',
                        },
                    ],
                    wordSize: [
                        {
                            value: '2',
                        },
                        {
                            value: '3',
                        },
                        {
                            value: '6',
                            default: true,
                        },
                    ],
                },
            },
            {
                value: 'blastp',
                label: 'Blastp',
                key: 'blastp',
                children: {
                    matrix: [
                        {
                            value: 'PAM30',
                        },
                        {
                            value: 'PAM70',
                        },
                        {
                            value: 'PAM250',
                        },
                        {
                            value: 'BLOSUM80',
                        },
                        {
                            value: 'BLOSUM62',
                            default: true,
                        },
                        {
                            value: 'BLOSUM45',
                        },
                        {
                            value: 'BLOSUM50',
                        },
                        {
                            value: 'BLOSUM90',
                        },
                    ],
                    wordSize: [
                        {
                            value: '2',
                        },
                        {
                            value: '3',
                            default: true,
                        },
                        {
                            value: '6',
                        },
                    ],
                },
            },
            {
                value: 'blastp-short',
                label: 'Blastp-short',
                key: 'blastpShort',
                default: true,
                children: {
                    matrix: [
                        {
                            value: 'PAM30',
                            default: true,
                        },
                        {
                            value: 'PAM70',
                        },
                        {
                            value: 'PAM250',
                        },
                        {
                            value: 'BLOSUM80',
                        },
                        {
                            value: 'BLOSUM62',
                        },
                        {
                            value: 'BLOSUM45',
                        },
                        {
                            value: 'BLOSUM50',
                        },
                        {
                            value: 'BLOSUM90',
                        },
                    ],
                    wordSize: [
                        {
                            value: '2',
                            default: true,
                        },
                        {
                            value: '3',
                        },
                        {
                            value: '6',
                        },
                    ],
                },
            },
        ],
        similarity: false,
        automaticShow: true,
        automaticLong: false,
        lowComplexityRegion: false,
    },
    // Protein Input - Nucleotide Database
    protTypeNucDbConfigs: {
        algorithmOptions: [
            {
                value: 'tblastn-fast',
                label: 'Tblastn-fast',
                key: 'tblastnFast',
                default: true,
                children: {
                    matrix: [
                        {
                            value: 'PAM30',
                        },
                        {
                            value: 'PAM70',
                        },
                        {
                            value: 'PAM250',
                        },
                        {
                            value: 'BLOSUM80',
                        },
                        {
                            value: 'BLOSUM62',
                            default: true,
                        },
                        {
                            value: 'BLOSUM45',
                        },
                        {
                            value: 'BLOSUM50',
                        },
                        {
                            value: 'BLOSUM90',
                        },
                    ],
                    wordSize: [
                        {
                            value: '2',
                        },
                        {
                            value: '3',
                        },
                        {
                            value: '6',
                            default: true,
                        },
                    ],
                },
            },
        ],
        similarity: false,
        automaticShow: false,
        lowComplexityRegion: true,
    },
};

// 的 short 算法的配置
export const shortAlgorithmConfig = {
    nucTypeNucDbConfigs: {
        wordSize: [
            {
                value: '4',
                default: true,
            },
            {
                value: '7',
            },
            {
                value: '11',
            },
            {
                value: '15',
            },
        ],
    },
    nucTypeProtDbConfigs: {
        wordSize: [
            {
                value: '2',
                default: true,
            },
            {
                value: '3',
            },
            {
                value: '6',
            },
        ],
    },
    protTypeProtDbConfigs: {
        wordSize: [
            {
                value: '2',
                default: true,
            },
            {
                value: '3',
            },
            {
                value: '6',
            },
        ],
    },
    protTypeNucDbConfigs: {
        wordSize: [
            {
                value: '2',
                default: true,
            },
            {
                value: '3',
            },
            {
                value: '6',
            },
        ],
    },
};

class GapCostItem {
    constructor(value, isDefault = false) {
        this.value = value;
        this.isDefault = isDefault;
    }

    get label() {
        if (this.value) {
            const values = this.value.split(',');
            return `Existence: ${values[0]} Extension: ${values[1]}`;
        }
        return '';
    }
}

const megablastGapCostOptions = {
    /*
    Linear
    Existence: 5 Extension: 2
    Existence: 2 Extension: 2
    Existence: 1 Extension: 2
    Existence: 0 Extension: 2
    Existence: 3 Extension: 1
    Existence: 2 Extension: 1
    Existence: 1 Extension: 1
    */
    '1,-2': [
        { value: '0,0', label: 'Linear', isDefault: true },
        new GapCostItem('5,2'),
        new GapCostItem('2,2'),
        new GapCostItem('1,2'),
        new GapCostItem('0,2'),
        new GapCostItem('3,1'),
        new GapCostItem('2,1'),
        new GapCostItem('1,1'),
    ],
    /*
    Linear
    Existence: 5 Extension: 2
    Existence: 2 Extension: 2
    Existence: 1 Extension: 2
    Existence: 0 Extension: 2
    Existence: 2 Extension: 1
    Existence: 1 Extension: 1
    */
    '1,-3': [
        { value: '0,0', label: 'Linear', isDefault: true },
        new GapCostItem('5,2'),
        new GapCostItem('2,2'),
        new GapCostItem('1,2'),
        new GapCostItem('0,2'),
        new GapCostItem('2,1'),
        new GapCostItem('1,1'),
    ],
    /*
    Linear
    Existence: 5 Extension: 2
    Existence: 1 Extension: 2
    Existence: 0 Extension: 2
    Existence: 2 Extension: 1
    Existence: 1 Extension: 1
    */
    '1,-4': [
        { value: '0,0', label: 'Linear', isDefault: true },
        new GapCostItem('5,2'),
        new GapCostItem('1,2'),
        new GapCostItem('0,2'),
        new GapCostItem('2,1'),
        new GapCostItem('1,1'),
    ],
    /*
    Linear
    Existence: 4 Extension: 4
    Existence: 2 Extension: 4
    Existence: 0 Extension: 4
    Existence: 3 Extension: 3
    Existence: 6 Extension: 2
    Existence: 5 Extension: 2
    Existence: 4 Extension: 2
    Existence: 2 Extension: 2
    */
    '2,-3': [
        { value: '0,0', label: 'Linear', isDefault: true },
        new GapCostItem('4,4'),
        new GapCostItem('2,4'),
        new GapCostItem('0,4'),
        new GapCostItem('3,3'),
        new GapCostItem('6,2'),
        new GapCostItem('5,2'),
        new GapCostItem('4,2'),
        new GapCostItem('2,2'),
    ],
    /*
    Linear
    Existence: 12 Extension: 8
    Existence: 6 Extension: 5
    Existence: 5 Extension: 5
    Existence: 4 Extension: 5
    Existence: 3 Extension: 5
    */
    '4,-5': [
        { value: '0,0', label: 'Linear', isDefault: true },
        new GapCostItem('12,8'),
        new GapCostItem('6,5'),
        new GapCostItem('5,5'),
        new GapCostItem('4,5'),
        new GapCostItem('3,5'),
    ],
    /*
    Existence: 5 Extension: 2
    Existence: 3 Extension: 2
    Existence: 2 Extension: 2
    Existence: 1 Extension: 2
    Existence: 0 Extension: 2
    Existence: 4 Extension: 1
    Existence: 3 Extension: 1
    Existence: 2 Extension: 1
    */
    '1,-1': [
        new GapCostItem('5,2', true),
        new GapCostItem('3,2'),
        new GapCostItem('2,2'),
        new GapCostItem('1,2'),
        new GapCostItem('0,2'),
        new GapCostItem('4,1'),
        new GapCostItem('3,1'),
        new GapCostItem('2,1'),
    ],
};
// blastn blastShort
const blastnAndShortGapCost = {
    '1,-2': [
        /*
        Existence: 5 Extension: 2 (默认)
        Existence: 2 Extension: 2
        Existence: 1 Extension: 2
        Existence: 0 Extension: 2
        Existence: 3 Extension: 1
        Existence: 2 Extension: 1
        Existence: 1 Extension: 1
        */
        new GapCostItem('5,2', true),
        new GapCostItem('2,2'),
        new GapCostItem('1,2'),
        new GapCostItem('0,2'),
        new GapCostItem('3,1'),
        new GapCostItem('2,1'),
        new GapCostItem('1,1'),
    ],
    '1,-3': [
        /*
        Existence: 5 Extension: 2 (默认)
        Existence: 2 Extension: 2
        Existence: 1 Extension: 2
        Existence: 0 Extension: 2
        Existence: 2 Extension: 1
        Existence: 1 Extension: 1
        */
        new GapCostItem('5,2', true),
        new GapCostItem('2,2'),
        new GapCostItem('1,2'),
        new GapCostItem('0,2'),
        new GapCostItem('2,1'),
        new GapCostItem('1,1'),
    ],
    '1,-4': [
        /*
        Existence: 5 Extension: 2 (默认)
        Existence: 1 Extension: 2
        Existence: 0 Extension: 2
        Existence: 2 Extension: 1
        Existence: 1 Extension: 1
        */
        new GapCostItem('5,2', true),
        new GapCostItem('1,2'),
        new GapCostItem('0,2'),
        new GapCostItem('2,1'),
        new GapCostItem('1,1'),
    ],
    '2,-3': [
        /*
        Existence: 4 Extension: 4
        Existence: 2 Extension: 4
        Existence: 0 Extension: 4
        Existence: 3 Extension: 3
        Existence: 6 Extension: 2
        Existence: 5 Extension: 2 (默认)
        Existence: 4 Extension: 2
        Existence: 2 Extension: 2
        */
        new GapCostItem('4,4'),
        new GapCostItem('2,4'),
        new GapCostItem('0,4'),
        new GapCostItem('3,3'),
        new GapCostItem('6,2'),
        new GapCostItem('5,2', true),
        new GapCostItem('4,2'),
        new GapCostItem('2,2'),
    ],
    '4,-5': [
        /*
        Existence: 12 Extension: 8 (默认)
        Existence: 6 Extension: 5
        Existence: 5 Extension: 5
        Existence: 4 Extension: 5
        Existence: 3 Extension: 5
        */
        new GapCostItem('12,8', true),
        new GapCostItem('6,5'),
        new GapCostItem('5,5'),
        new GapCostItem('4,5'),
        new GapCostItem('3,5'),
    ],
    '1,-1': [
        /*
        Existence: 5 Extension: 2 (默认)
        Existence: 3 Extension: 2
        Existence: 2 Extension: 2
        Existence: 1 Extension: 2
        Existence: 0 Extension: 2
        Existence: 4 Extension: 1
        Existence: 3 Extension: 1
        Existence: 2 Extension: 1
        */
        new GapCostItem('5,2', true),
        new GapCostItem('3,2'),
        new GapCostItem('2,2'),
        new GapCostItem('1,2'),
        new GapCostItem('0,2'),
        new GapCostItem('4,1'),
        new GapCostItem('3,1'),
        new GapCostItem('2,1'),
    ],
};

const TblastnFastGapCost = {
    PAM30: [
        /*
        Existence: 7 Extension: 2 (默认)
        Existence: 6 Extension: 2
        Existence: 5 Extension: 2
        Existence: 10 Extension: 1
        Existence: 9 Extension: 1
        Existence: 8 Extension: 1
        Existence: 13 Extension: 3
        Existence: 15 Extension: 3
        Existence: 14 Extension: 1
        Existence: 14 Extension: 2
        */
        new GapCostItem('7,2', true),
        new GapCostItem('6,2'),
        new GapCostItem('5,2'),
        new GapCostItem('10,1'),
        new GapCostItem('9,1'),
        new GapCostItem('8,1'),
        new GapCostItem('13,3'),
        new GapCostItem('15,3'),
        new GapCostItem('14,1'),
        new GapCostItem('14,2'),
    ],
    PAM70: [
        /*
        Existence: 8 Extension: 2
        Existence: 7 Extension: 2
        Existence: 6 Extension: 2
        Existence: 11 Extension: 1
        Existence: 10 Extension: 1 （默认）
        Existence: 9 Extension: 1
        Existence:12 Extension: 3
        Existence: 11 Extension: 2
        */
        new GapCostItem('8,2'),
        new GapCostItem('7,2'),
        new GapCostItem('6,2'),
        new GapCostItem('11,1'),
        new GapCostItem('10,1', true),
        new GapCostItem('9,1'),
        new GapCostItem('12,3'),
        new GapCostItem('11,2'),
    ],
    PAM250: [
        /*
        Existence: 15 Extension: 3
        Existence: 14 Extension: 3
        Existence: 13 Extension: 3
        Existence: 12 Extension: 3
        Existence: 11 Extension: 3
        Existence: 17 Extension: 2
        Existence: 16 Extension: 2
        Existence: 15 Extension: 2
        Existence: 14 Extension: 2 （默认）
        Existence: 13 Extension: 2
        Existence: 21 Extension: 1
        Existence: 20 Extension: 1
        Existence: 19 Extension: 1
        Existence: 18 Extension: 1
        Existence: 17 Extension: 1
        */
        new GapCostItem('15,3'),
        new GapCostItem('14,3'),
        new GapCostItem('13,3'),
        new GapCostItem('12,3'),
        new GapCostItem('11,3'),
        new GapCostItem('17,2'),
        new GapCostItem('16,2'),
        new GapCostItem('15,2'),
        new GapCostItem('14,2', true),
        new GapCostItem('13,2'),
        new GapCostItem('21,1'),
        new GapCostItem('20,1'),
        new GapCostItem('19,1'),
        new GapCostItem('18,1'),
        new GapCostItem('17,1'),
    ],
    BLOSUM80: [
        /*
        Existence: 8 Extension: 2
        Existence: 7 Extension: 2
        Existence: 6 Extension: 2
        Existence: 11 Extension: 1
        Existence: 10 Extension: 1 （默认）
        Existence: 9 Extension: 1
        */
        new GapCostItem('8,2'),
        new GapCostItem('7,2'),
        new GapCostItem('6,2'),
        new GapCostItem('11,1'),
        new GapCostItem('10,1', true),
        new GapCostItem('9,1'),
    ],
    BLOSUM62: [
        /*
        Existence: 11 Extension: 2
        Existence: 10 Extension: 2
        Existence: 9 Extension: 2
        Existence: 8 Extension: 2
        Existence: 7 Extension: 2
        Existence: 6 Extension: 2
        Existence: 13 Extension: 1
        Existence: 12 Extension: 1
        Existence: 11 Extension: 1 （默认）
        Existence: 10 Extension: 1
        Existence: 9 Extension: 1
        */
        new GapCostItem('11,2'),
        new GapCostItem('10,2'),
        new GapCostItem('9,2'),
        new GapCostItem('8,2'),
        new GapCostItem('7,2'),
        new GapCostItem('6,2'),
        new GapCostItem('13,1'),
        new GapCostItem('12,1'),
        new GapCostItem('11,1', true),
        new GapCostItem('10,1'),
        new GapCostItem('9,1'),
    ],
    BLOSUM45: [
        /*
        Existence: 13 Extension: 3
        Existence: 12 Extension: 3
        Existence: 11 Extension: 3
        Existence: 10 Extension: 3
        Existence: 15 Extension: 2 （默认）
        Existence: 14 Extension: 2
        Existence: 13 Extension: 2
        Existence: 12 Extension: 2
        Existence: 19 Extension: 1
        Existence: 18 Extension: 1
        Existence: 17 Extension: 1
        Existence: 16 Extension: 1
        */
        new GapCostItem('13,3'),
        new GapCostItem('12,3'),
        new GapCostItem('11,3'),
        new GapCostItem('10,3'),
        new GapCostItem('15,2', true),
        new GapCostItem('14,2'),
        new GapCostItem('13,2'),
        new GapCostItem('12,2'),
        new GapCostItem('19,1'),
        new GapCostItem('18,1'),
        new GapCostItem('17,1'),
        new GapCostItem('16,1'),
    ],
    BLOSUM50: [
        /*
        Existence: 13 Extension: 3
        Existence: 12 Extension: 3
        Existence: 11 Extension: 3
        Existence: 10 Extension: 3
        Existence: 9 Extension: 3
        Existence: 16 Extension: 2
        Existence: 15 Extension: 2
        Existence: 14 Extension: 2
        Existence: 13 Extension: 2 （默认）
        Existence: 12 Extension: 2
        Existence: 19 Extension: 1
        Existence: 18 Extension: 1
        Existence: 17 Extension: 1
        Existence: 16 Extension: 1
        Existence: 15 Extension: 1
        */
        new GapCostItem('13,3'),
        new GapCostItem('12,3'),
        new GapCostItem('11,3'),
        new GapCostItem('10,3'),
        new GapCostItem('9,3'),
        new GapCostItem('16,2'),
        new GapCostItem('15,2'),
        new GapCostItem('14,2'),
        new GapCostItem('13,2', true),
        new GapCostItem('12,2'),
        new GapCostItem('19,1'),
        new GapCostItem('18,1'),
        new GapCostItem('17,1'),
        new GapCostItem('16,1'),
        new GapCostItem('15,1'),
    ],
    BLOSUM90: [
        /*
        Existence: 9 Extension: 2
        Existence: 8 Extension: 2
        Existence: 7 Extension: 2
        Existence: 6 Extension: 2
        Existence: 11 Extension: 1
        Existence: 10 Extension: 1 （默认）
        Existence: 9 Extension: 1
        */
        new GapCostItem('9,2'),
        new GapCostItem('8,2'),
        new GapCostItem('7,2'),
        new GapCostItem('6,2'),
        new GapCostItem('11,1'),
        new GapCostItem('10,1', true),
        new GapCostItem('9,1'),
    ],
};

// blastp
const blastpGapCost = {
    PAM30: [
        /*
        Existence: 7 Extension: 2
        Existence: 6 Extension: 2
        Existence: 5 Extension: 2
        Existence: 10 Extension: 1
        Existence: 9 Extension: 1 (默认)
        Existence: 8 Extension: 1
        Existence: 13 Extension: 3
        Existence: 15 Extension: 3
        Existence: 14 Extension: 1
        Existence: 14 Extension: 2
        */
        new GapCostItem('7,2'),
        new GapCostItem('6,2'),
        new GapCostItem('5,2'),
        new GapCostItem('10,1'),
        new GapCostItem('9,1', true),
        new GapCostItem('8,1'),
        new GapCostItem('13,3'),
        new GapCostItem('15,3'),
        new GapCostItem('14,1'),
        new GapCostItem('14,2'),
    ],
    PAM70: [
        /*
        Existence: 8 Extension: 2
        Existence: 7 Extension: 2
        Existence: 6 Extension: 2
        Existence: 11 Extension: 1
        Existence: 10 Extension: 1 (默认)
        Existence: 9 Extension: 1
        Existence:12 Extension: 3
        Existence: 11 Extension: 2
        */
        new GapCostItem('8,2'),
        new GapCostItem('7,2'),
        new GapCostItem('6,2'),
        new GapCostItem('11,1'),
        new GapCostItem('10,1', true),
        new GapCostItem('9,1'),
        new GapCostItem('12,3'),
        new GapCostItem('11,2'),
    ],
    PAM250: [
        /*
        Existence: 15 Extension: 3
        Existence: 14 Extension: 3
        Existence: 13 Extension: 3
        Existence: 12 Extension: 3
        Existence: 11 Extension: 3
        Existence: 17 Extension: 2
        Existence: 16 Extension: 2
        Existence: 15 Extension: 2
        Existence: 14 Extension: 2 (默认)
        Existence: 13 Extension: 2
        Existence: 21 Extension: 1
        Existence: 20 Extension: 1
        Existence: 19 Extension: 1
        Existence: 18 Extension: 1
        Existence: 17 Extension: 1
        */
        new GapCostItem('15,3'),
        new GapCostItem('14,3'),
        new GapCostItem('13,3'),
        new GapCostItem('12,3'),
        new GapCostItem('11,3'),
        new GapCostItem('17,2'),
        new GapCostItem('16,2'),
        new GapCostItem('15,2'),
        new GapCostItem('14,2', true),
        new GapCostItem('21,1'),
        new GapCostItem('20,1'),
        new GapCostItem('19,1'),
        new GapCostItem('18,1'),
        new GapCostItem('17,1'),
    ],
    BLOSUM80: [
        /*
        Existence: 8 Extension: 2
        Existence: 7 Extension: 2
        Existence: 6 Extension: 2
        Existence: 11 Extension: 1
        Existence: 10 Extension: 1 （默认）
        Existence: 9 Extension: 1
        */
        new GapCostItem('8,2'),
        new GapCostItem('7,2'),
        new GapCostItem('6,2'),
        new GapCostItem('11,1'),
        new GapCostItem('10,1', true),
        new GapCostItem('9,1'),
    ],
    BLOSUM62: [
        /*
        Existence: 11 Extension: 2
        Existence: 10 Extension: 2
        Existence: 9 Extension: 2
        Existence: 8 Extension: 2
        Existence: 7 Extension: 2
        Existence: 6 Extension: 2
        Existence: 13 Extension: 1
        Existence: 12 Extension: 1
        Existence: 11 Extension: 1 （默认）
        Existence: 10 Extension: 1
        Existence: 9 Extension: 1
        */
        new GapCostItem('11,2'),
        new GapCostItem('10,2'),
        new GapCostItem('9,2'),
        new GapCostItem('8,2'),
        new GapCostItem('7,2'),
        new GapCostItem('6,2'),
        new GapCostItem('13,1'),
        new GapCostItem('12,1'),
        new GapCostItem('11,1', true),
        new GapCostItem('10,1'),
        new GapCostItem('9,1'),
    ],
    BLOSUM45: [
        /*
        Existence: 13 Extension: 3
        Existence: 12 Extension: 3
        Existence: 11 Extension: 3
        Existence: 10 Extension: 3
        Existence: 15 Extension: 2 （默认）
        Existence: 14 Extension: 2
        Existence: 13 Extension: 2
        Existence: 12 Extension: 2
        Existence: 19 Extension: 1
        Existence: 18 Extension: 1
        Existence: 17 Extension: 1
        Existence: 16 Extension: 1
        */
        new GapCostItem('13,3'),
        new GapCostItem('12,3'),
        new GapCostItem('11,3'),
        new GapCostItem('10,3'),
        new GapCostItem('15,2', true),
        new GapCostItem('14,2'),
        new GapCostItem('13,2'),
        new GapCostItem('12,2'),
        new GapCostItem('19,1'),
        new GapCostItem('18,1'),
        new GapCostItem('17,1'),
        new GapCostItem('16,1'),
    ],
    BLOSUM50: [
        /*
        Existence: 13 Extension: 3
        Existence: 12 Extension: 3
        Existence: 11 Extension: 3
        Existence: 10 Extension: 3
        Existence: 9 Extension: 3
        Existence: 16 Extension: 2
        Existence: 15 Extension: 2
        Existence: 14 Extension: 2
        Existence: 13 Extension: 2 （默认）
        Existence: 12 Extension: 2
        Existence: 19 Extension: 1
        Existence: 18 Extension: 1
        Existence: 17 Extension: 1
        Existence: 16 Extension: 1
        Existence: 15 Extension: 1
        */
        new GapCostItem('13,3'),
        new GapCostItem('12,3'),
        new GapCostItem('11,3'),
        new GapCostItem('10,3'),
        new GapCostItem('9,3'),
        new GapCostItem('16,2'),
        new GapCostItem('15,2'),
        new GapCostItem('14,2'),
        new GapCostItem('13,2', true),
        new GapCostItem('19,1'),
        new GapCostItem('18,1'),
        new GapCostItem('17,1'),
        new GapCostItem('16,1'),
        new GapCostItem('15,1'),
    ],
    BLOSUM90: [
        /*
        Existence: 9 Extension: 2
        Existence: 8 Extension: 2
        Existence: 7 Extension: 2
        Existence: 6 Extension: 2
        Existence: 11 Extension: 1
        Existence: 10 Extension: 1 （默认）
        Existence: 9 Extension: 1
        */
        new GapCostItem('9,2'),
        new GapCostItem('8,2'),
        new GapCostItem('7,2'),
        new GapCostItem('6,2'),
        new GapCostItem('11,1'),
        new GapCostItem('10,1', true),
        new GapCostItem('9,1'),
    ],
};

export const gapCostOptionsByAlgorithm = {
    megablast: megablastGapCostOptions,
    blastn: blastnAndShortGapCost,
    'blastn-short': blastnAndShortGapCost,
    // 蛋白区域
    'tblastn-fast': TblastnFastGapCost,
    'blastp-fast': blastpGapCost,
    blastp: blastpGapCost,
    'blastp-short': blastpGapCost,
    'blastx-fast': blastpGapCost,
};

export const configKeys = {
    protTypeProtDbConfigs: 'protTypeProtDbConfigs',
    nucTypeNucDbConfigs: 'nucTypeNucDbConfigs',
    nucTypeProtDbConfigs: 'nucTypeProtDbConfigs',
    protTypeNucDbConfigs: 'protTypeNucDbConfigs',
};

export const settingFieldConfig = {
    [SEARCH_TYPES.sequence]: [
        'perc_identity',
        'q_perc_identity',
        'qcov_hsp_perc',
        'subject_length',
        's_perc_identity',
        'scov_hsp_perc',
        'evalue',
        'ungapped',
        'algorithm',
        'matrix',
        'word_size',
        'gapCosts',
        'matchScores',
    ],
    [SEARCH_TYPES.cdr]: [
        'evalue',
        'ungapped',
    ],
    [SEARCH_TYPES.motif]: [
        'subject_length',
        'perc_identity',
        'qcov_hsp_perc',
        'scov_hsp_perc',
        'evalue',
    ],
    [SEARCH_TYPES.fragment]: [
        'perc_identity',
        'evalue',
        'ungapped',
    ],
};

export const mismatchOptions = [
    0, 1, 2,
];

export const evalueOptions = [
    {
        value: 0.0001,
        label: '0.0001',
    },
    {
        value: 0.001,
        label: '0.001',
    },
    {
        value: 0.01,
        label: '0.01',
    },
    {
        value: 0.1,
        label: '0.1',
    },
    {
        value: 1,
        label: '1',
    },
    {
        value: 10,
        label: '10',
    },
    {
        value: 100,
        label: '100',
    },
    {
        value: 1000,
        label: '1,000',
    },
    {
        value: 10000,
        label: '10,000',
    },
    {
        value: 100000,
        label: '100,000',
    },
    {
        value: 1000000,
        label: '1,000,000',
    },
];

export const targetSeqLimitOptions = [
    {
        value: 1000,
        label: 1000,
    },
    {
        value: 5000,
        label: 5000,
    },
    {
        value: 10000,
        label: 10000,
    },
    {
        value: 50000,
        label: 50000,
    },
];

export default {
    configOptions,
    configKeys,
    settingFieldConfig,
    mismatchOptions,
    evalueOptions,
    shortAlgorithmConfig,
    targetSeqLimitOptions,
};
